<template>
    <div class="leads-meeting-and-calls">
        <MeetingAndCallsModal :show_meeting_and_calls.sync="modals.show_meeting_and_calls" :timelines="timelines"/>
        <EditMeetingEventVueModal :edit_meeting.sync="modals.edit_meeting" :timelines="timelines" :timelineEdited="timelineEdited" @getTimeline="getTimeline"/>
        <b-card no-body>
            <b-card-header class="p-3 mb-4">
                <b-row align-v="center">
                    <b-col cols="10" class="d-flex align-items-center">
                        <h3 class="mb-0">
                            Meeting &amp; Calls
                        </h3>
                    </b-col>
                    <b-col cols="2" v-if="timelines.length > 0">
                        <el-button class="float-right py-0" type="text" @click="openModal">View All</el-button>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-container v-if="timelines.length > 0">
                <b-row v-for="(timeline, index) in timelines" :key="index">
                    <b-col cols="12">
                        <h4 v-if="timeline.meeting_id">{{ timeline.start_at | dateFormatString }} - {{ timeline.end_at | dateFormatString }}</h4>
                        <h4 v-if="timeline.call_id">{{ timeline.start_at | dateFormatString }}</h4>
                    </b-col>
                    <b-col cols="12">
                        <div class="border rounded p-2 mb-4">
                            <div class="d-flex align-items-centers justify-content-between">
                                <div class="d-flex">
                                    <div class="my-auto">
                                        <svg v-if="timeline.meeting_id" xmlns="http://www.w3.org/2000/svg" class="mr-2" width="48" height="20" viewBox="0 0 448 512"><path fill="#5D79E3" d="M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"/></svg>
                                        <svg v-if="timeline.call_id" xmlns="http://www.w3.org/2000/svg" class="mr-1" width="48" height="20" viewBox="0 0 24 24"><path fill="#5D79E3" d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02c-.37-1.11-.56-2.3-.56-3.53c0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99C3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/></svg>
                                    </div>
                                    <div>
                                        <h4 class="mb-0 pl-2">{{ timeline.subject }}</h4>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 256 256"><path fill="currentColor" d="M156 128a28 28 0 1 1-28-28 28 28 0 0 1 28 28Z"/></svg>
                                        <span>{{ timeline.start_at | timeFormatString }} - {{ timeline.end_at | timeFormatString }}</span>
                                    </div>
                                </div>
                                <div class="d-flex flex-column align-items-center justify-content-center">
                                    <span v-if="timeline.meeting_id" @click="openEditTimelineModal(timeline.meeting_id ? timeline.meeting_id : timeline.call_id, timeline.meeting_id ? 1 : 2)" cols="auto" class="text-primary cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="mr-1" width="16" height="16" viewBox="0 0 512 512"><path fill="#5D79E3" d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0l-30.1 30 97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2l-18.7-18.6zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5l167.3-167.4-98-98-167.3 167.4zM96 64c-53 0-96 43-96 96v256c0 53 43 96 96 96h256c53 0 96-43 96-96v-96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"/></svg>
                                    </span>
                                    <!-- <span @click="deleteThisTimeline(timeline.meeting_id ? timeline.meeting_id : timeline.call_id, timeline.meeting_id ? 1 : 2)" cols="auto" class="text-danger cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="mr-1" width="12" height="16" viewBox="0 0 448 512"><path fill="#DF3030" d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"/></svg>
                                    </span> -->
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <b-container v-else>
                <div class="d-flex align-items-center px-1 pb-3">
                    <p class="text-muted m-0">No data found.</p>
                </div>
            </b-container>
        </b-card>
    </div>
</template>
<script>
import { Button } from 'element-ui'
import MeetingAndCallsModal from '@/views/Leads/LeadsProfile/LeadsModals/MeetingAndCallsModal'
import ScheduleMeetingModal from '@/views/Leads/LeadsProfile/LeadsModals/ScheduleMeetingModal'
import EditMeetingEventVueModal from '@/views/Meeting/MeetingModals/EditMeetingEvent'
import {
    helperFunctionMixin,
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'
import EditMeetingEventVue from '../../../Meeting/MeetingModals/EditMeetingEvent.vue'
import { EventBus } from '@/main'

export default {
    components: {
        MeetingAndCallsModal,
        [Button.name]: Button,
        EditMeetingEventVueModal,
    },
    props:['lead'],
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    mounted(){
        this.getTimeline()
    },
    created(){
        EventBus.$on('refresh-meeting-and-call', this.getTimeline);
    },
    data() {
        return {
            modals: {
                show_meeting_and_calls: false,
                edit_meeting: false
            },
            timelines:[

            ],
            meetingList: [],
            timelineEdited: {},
            hrhr:{},
        }
    },
    methods: {
        openModal() {
            this.modals.show_meeting_and_calls = true;
        },
        getTimeline(){
                axios.get(services.lead + 'leads/'+this.lead.lead_id, {headers: getHeader()})
                    .then(res => {
                        this.timelines = [...res.data.data.meeting, ...res.data.data.call]
                        this.timelines.sort((a, b) => new Date(b.start_at) - new Date(a.start_at));
                        // this.timelines.filter(x => x.meeting_id ? this.meetingList.push(x) : "")

                    })
                    .catch(e => {
                        console.log(e)
                        this.isTableLoading = false
                        this.errorFunction(e)
                    })
        },
        openEditTimelineModal(data, type){
            if(type == 1){
                this.timelineEdited =  this.timelines.filter(x => x.meeting_id? (x.meeting_id == data ? x : "") : "")[0];
                // this.timelineEdited = this.timelines.filter(x => x.meeting_id? (x.meeting_id == data ? x : "") : "")
                
            }else{
                this.timelineEdited = this.timelines.filter(x => x.call_id? (x.call_id == data ? x : "") : "")
            }
            this.modals.edit_meeting = true
        },
        deleteThisTimeline(data, type){

            let timelineType = type == 1 ? 'meeting/' : 'call/';

            swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(services.lead + timelineType + data, {headers: getHeader()})
                    .then(res => {
                            this.timelines = this.timelines.filter(x => x.meeting_id ? x.meeting_id !== data : x.call_id !== data)
                            this.notifySuccess('<b>Status </b> - Successfully Deleted.')
                            return 
                        })
                        .catch(e => {
                            console.log(e)
                            this.isTableLoading = false
                            this.errorFunction(e)
                        })
                        
                }
            })
        }
    }
}
</script>